import { Box } from '@material-ui/core';

import { Icon } from '@/components/shared/components/Icon';
import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { useAddressFormFields } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/hooks/useAddressFormFields';
import { AddressMode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/types/AddressMode';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export const ConfirmChangesButton = ({ disabled }: { disabled: boolean }) => {
  const { setMode } = useAddressContext();
  const { updateFormattedAddressField, saveTemporaryCardData, getValidation } = useAddressFormFields();

  const handleClick = async () => {
    updateFormattedAddressField();
    const areFieldsValid = await getValidation();
    if (areFieldsValid) {
      saveTemporaryCardData();
      setMode(AddressMode.CONFIRM);
    }
  };

  return (
    <StandardButton size="small" variant="contained" onClick={handleClick} disabled={disabled}>
      <Box display={'flex'} gridGap={'6px'} alignItems={'center'}>
        <Text tId={'CONFIRM_CHANGES'} />
        <Icon size={16}>check</Icon>
      </Box>
    </StandardButton>
  );
};
